import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import WebhooksList from './WebhooksList';
import translate from 'components/hoc/translate';

const UsersListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.webhooks.title') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <WebhooksList
                { ...props }
            />
        </div>
    );
};

UsersListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(UsersListContainer);



// WEBPACK FOOTER //
// ./src/pages/webhooks/list/WebhooksListContainer.js